var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThunderstorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.6 382.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daa79d;}.cls-2{fill:#f6bdac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy",
    "data-name": "Layer 2 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275,80.12a63.85,63.85,0,0,0-87.8-55.64A83.62,83.62,0,0,0,44.49,83.64c0,.16,0,.32,0,.48A67.45,67.45,0,0,0,67.44,215h77.31l-25.06,57.75a7.51,7.51,0,0,0,6.88,10.49h25.76L123,372.52a7.5,7.5,0,0,0,13.22,6.71L231.63,246a7.5,7.5,0,0,0-6.1-11.87H200.66L210,215h64.21A67.44,67.44,0,0,0,275,80.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.93,249.17l-58.41,81.55,17.29-52.65a7.5,7.5,0,0,0-7.12-9.84H138l22.1-51L193,215.62l-11,22.78a7.51,7.51,0,0,0,6.75,10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112,244.12,94.46,270.9a8.23,8.23,0,0,1-13.78-9L98.22,235.1a8.23,8.23,0,1,1,13.77,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.59,244.12,33.06,270.9a8.23,8.23,0,0,1-11.4,2.38h0a8.23,8.23,0,0,1-2.38-11.39L36.82,235.1a8.23,8.23,0,1,1,13.77,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.19,319.82l-8.73,13.33a8.23,8.23,0,1,1-13.77-9l8.72-13.33a8.24,8.24,0,0,1,11.4-2.38h0A8.24,8.24,0,0,1,99.19,319.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.48,270,237,296.74a8.23,8.23,0,0,1-11.4,2.38h0a8.23,8.23,0,0,1-2.38-11.39l17.54-26.79a8.24,8.24,0,0,1,11.4-2.38h0A8.24,8.24,0,0,1,254.48,270Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.24,316.72l-12.79,19.53a8.23,8.23,0,1,1-13.77-9l12.79-19.53a8.22,8.22,0,0,1,11.39-2.38h0A8.23,8.23,0,0,1,283.24,316.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.83,244.12,291.29,270.9a8.22,8.22,0,0,1-11.39,2.38h0a8.22,8.22,0,0,1-2.38-11.39l17.53-26.79a8.23,8.23,0,0,1,13.78,9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstorm);
export default __webpack_public_path__ + "static/media/thunderstorm.48f9b244e87c7b6d5c871672f5fb241b.svg";
export { ForwardRef as ReactComponent };